import type {
    NeglectedOrDelinquentHighSchoolDiplomaModel,
} from './NeglectedOrDelinquentInformationModel';

export const DIPLOMA_FIELDS: {
    key: Exclude<
        keyof NeglectedOrDelinquentHighSchoolDiplomaModel, 'awardedHighSchoolDiploma'
    >;
    label: string;
}[] = [
    { key: 'studentsAwardedDiplomaWhileInProgram', label: 'While in the program' },
    {
        key: 'studentsAwardedDiplomaWithin90DaysOfExiting',
        label: 'Within 90 Days of Exiting',
    },
];
